module.exports = __webpack_public_path__ + "static/media/level-access-icon.d3ff94fe.svg";